import React from 'react';

const AlarmIcon = () => (
  <svg width='13' height='14' viewBox='0 0 13 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M4.63391 11.3334C5.00929 11.978 5.70045 12.4167 6.49995 12.4167C7.29945 12.4167 7.99062 11.978 8.36599 11.3334H4.63391Z'
      fill='white'
      opacity='0.5'
    />
    <path
      d='M11.375 10.7916H1.625V9.31775L1.9955 9.19479C2.74571 8.944 3.25 8.24525 3.25 7.45388V5.91663C3.25 4.12425 4.70763 2.66663 6.5 2.66663C8.29238 2.66663 9.75 4.12425 9.75 5.91663V7.45388C9.75 8.24525 10.2543 8.944 11.0045 9.19533L11.375 9.31775V10.7916ZM3.26896 9.70829H9.73158C9.07021 9.16554 8.66667 8.34654 8.66667 7.45388V5.91663C8.66667 4.72225 7.69492 3.74996 6.5 3.74996C5.30508 3.74996 4.33333 4.72225 4.33333 5.91663V7.45388C4.33333 8.34654 3.92979 9.16554 3.26896 9.70829Z'
      fill='white'
      opacity='0.5'
    />
  </svg>
);

export default AlarmIcon;
